/**
 * Template registry. Each entry: { id, label, description, mount }.
 * mount(canvas, products, look, host) → { setActive, setPaused, retintActive, destroy }
 */
import { mount as popMount } from './pop/template.js';
import { mount as editorialMount } from './editorial/template.js';

export const templates = {
  pop: {
    id: 'pop',
    label: 'Pop',
    description: 'Vibrant block carousel. DTC drops, watches, candles.',
    mount: popMount,
  },
  editorial: {
    id: 'editorial',
    label: 'Editorial',
    description: 'Narrative fly-through. Luxury, single-line collections.',
    mount: editorialMount,
  },
};

export const DEFAULT_TEMPLATE = 'pop';
